<div class="main-container-create">
    <div class="dialog-header">
        <div class="title-text">
            <span *ngIf="this.data.mode == 'edit'">Edit</span>
            <span *ngIf="this.data.mode == 'clone'">Clone</span>
            <span *ngIf="this.data.mode != 'edit'">Create</span> 
            Badge
        </div>
        <div class="flex align-items-center">
            <button class="primary-button button-hover-effect save-button" (click)="saveConfig()" [style.background]="isSaving?'white':''" 
            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" > 
                <span class="material-symbols-outlined" *ngIf="!isSaving">save</span>
                <span style="margin-left: 1rem;" *ngIf="!isSaving">Save</span>
                <app-qubriux-loading [size]="25" *ngIf="isSaving"></app-qubriux-loading>
            </button>
            <button class="primary-button secondary-button button-hover-effect" (click)="closedialog(false)">Close</button>
        </div>
    </div>

    <app-qubriux-loading [size]="55" class="margin-auto" [loadingText]="'Fetching data...'" *ngIf="offersLoading || dataLoading"></app-qubriux-loading>
    <div class="main-content-container top-margin-standard" *ngIf="!(offersLoading || dataLoading)" >
        <div class="flex-row-1">
            <div class="flex gap-3 flex-1">
                <div class="width-50">
                    <label class="main-label-style">Name</label><span class="qb-imp-color">*</span>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter your badge name" maxlength="50" #inp [(ngModel)]="badgeConfig.name" (keydown)="errorFieldList = []">
                    </div>
                    <div class="input-sub">
                        <div class="error-text" *ngIf="errorFieldList.includes('NAME')">
                            Please enter valid name
                        </div>
                        <div class="error-text" *ngIf="errorFieldList.includes('NAMEEXIStS')">
                            Badge With name already exists. Please enter unique name
                        </div>
                        <div class="inp-text-left">{{inp.value.length}}/{{ inp.getAttribute('maxlength')}}</div>
                    </div>
                </div>
                <div class="flex-1">
                    <label class="main-label-style">Description</label>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter your description" maxlength="300" #inp2 [(ngModel)]="badgeConfig.description" (keydown)="errorFieldList = []">
                    </div>
                    <div class="input-sub">
                        <div class="inp-text-left">{{inp2.value.length}}/{{ inp2.getAttribute('maxlength')}}</div>
                    </div>
                </div>
            </div>
    
            <!-- <div class="flex">
                <div class="status-text">
                    Status
                </div>
                <mat-slide-toggle [(ngModel)]="badgeConfig.isActive"></mat-slide-toggle>
            </div> -->
    
        </div>
        <div class="flex-row-1 top-margin-standard" >
            <div class="flex gap-3 flex-1">
                <div class="width-50">
                    <label class="main-label-style">Alias Name</label>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter your alias badge name" maxlength="50" #inpAlias [(ngModel)]="badgeConfig.badgeNameAlias" (keydown)="errorFieldList = []">
                    </div>
                    <div class="input-sub">
                        <div class="error-text" *ngIf="errorFieldList.includes('ALIASNAME')">
                            Please enter valid alias name
                        </div>
                        <div class="inp-text-left">{{inpAlias.value.length}}/{{ inpAlias.getAttribute('maxlength')}}</div>
                    </div>
                </div>
                <div class="flex-1">
                    <label class="main-label-style">Alias Description</label>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="text" placeholder="Enter your alias description" maxlength="300" #inp2alias [(ngModel)]="badgeConfig.descriptionAlias" (keydown)="errorFieldList = []">
                    </div>
                    <div class="input-sub">
                        <div class="inp-text-left">{{inp2alias.value.length}}/{{ inp2alias.getAttribute('maxlength')}}</div>
                    </div>
                </div>
            </div>
    
            <!-- <div class="flex">
                <div class="status-text">
                    Status
                </div>
                <mat-slide-toggle [(ngModel)]="badgeConfig.isActive"></mat-slide-toggle>
            </div> -->
    
        </div>
    
        <div class="top-margin-standard flex upload-row">
            <div class="each-upload">
                <div class="d-flex align-items-center">
                    <label class="main-label-style">Upload Badge Image</label>
                    <span class="material-symbols-outlined remove-img" *ngIf="badgeConfig.badgeImageUrl" [matTooltip]="'Remove image'" (click)="badgeConfig.badgeImageUrl = null">cancel</span>
                </div>
                <div class="upload-coin-img" (click)="fileInput.click()" *ngIf="!badgeConfig.badgeImageUrl && !uploading1">
                    <div class="margin-0">
                        Click here to upload your image [.png .jpg]
                    </div>
                    <span class="material-symbols-outlined">
                        cloud_upload
                    </span>
                </div>
                <app-qubriux-loading [size]="35" *ngIf="uploading1"></app-qubriux-loading>
                <div *ngIf="badgeConfig.badgeImageUrl && !uploading1" class="img-plus-upload">
                    <img class="uploaded-image" [src]="badgeConfig.badgeImageUrl" />
                    <div class="upload-coin-img" (click)="fileInput.click()">
                        <div class="margin-0">
                            Click here to replace your image [.png .jpg]
                        </div>
                        <span class="material-symbols-outlined">
                            cloud_upload
                        </span>
                    </div>
                </div>
                <!-- <div class="error-text" *ngIf="errorFieldList.includes('BIU')">
                    Please upload an image
                </div> -->
                <input type="file" accept=".png, .jpg" #fileInput (change)="setUploadedFile($event,'primary');errorFieldList = []" hidden="true"/>
            </div>
    
            <div class="each-upload">
                <div class="d-flex align-items-center">
                    <label class="main-label-style">Upload Banner Image</label>
                    <span class="material-symbols-outlined remove-img" *ngIf="badgeConfig.bannerImageUrl" [matTooltip]="'Remove image'" (click)="badgeConfig.bannerImageUrl = null">cancel</span>
                </div>
                <div class="upload-coin-img" (click)="fileInput2.click()" *ngIf="!badgeConfig.bannerImageUrl && !uploading2">
                    <div class="margin-0">
                        Click here to upload your image [.png .jpg]
                    </div>
                    <span class="material-symbols-outlined">
                        cloud_upload
                    </span>
                </div>
                <app-qubriux-loading [size]="45" *ngIf="uploading2" class="center-loader"></app-qubriux-loading>
                <div *ngIf="badgeConfig.bannerImageUrl && !uploading2" class="img-plus-upload">
                    <img class="uploaded-image" [src]="badgeConfig.bannerImageUrl" />
                    <div class="upload-coin-img" (click)="fileInput2.click()">
                        <div class="margin-0">
                            Click here to replace your image [.png .jpg]
                        </div>
                        <span class="material-symbols-outlined">
                            cloud_upload
                        </span>
                    </div>
                </div>
                <input type="file" accept=".png, .jpg" #fileInput2 (change)="setUploadedFile($event,'secondary')" hidden="true"/>
            </div>
        </div>

        <div class="top-margin-standard">
            <label class="main-label-style">Rewards</label><span *ngIf="isEditDisabled" class="disabled-edit-text">Edit disabled as {{disableEditText}}</span>
        </div>
        <div class="reward-selector" [ngClass]="{'disabled-edit':isEditDisabled}">
            <div class="sp-col-2">
                <div class="reward-type-row" >
                    <div class="reward-type">Offers</div>
                    <mat-checkbox class="margin-left-10" color="primary" [checked]="rewardTypesSelected['OFFER']" (change)="checkRewardType($event,'OFFER')"></mat-checkbox>
                    <span class="error-text" *ngIf="errorFieldList.includes('OFFER')"> Please select an offer</span>
                </div>
                <div class="rp-name-inp-container" *ngIf="offerList.length > 3" [ngClass]="{'disabled-div': !rewardTypesSelected['OFFER']}">
                    <input class="rp-name-inp" type="text" placeholder="Search offer..." maxlength="300" [(ngModel)]="offerSearch" (keydown)="errorFieldList = []" [disabled]="!rewardTypesSelected['OFFER']">
                    <span class="material-symbols-outlined search-icon">search</span>
                </div>
                <div class="sp-col" [ngClass]="{'disabled-div': !rewardTypesSelected['OFFER']}">
                    <div *ngIf="getFilteredOffers().length == 0" class="no-offer-text">No offers found</div>
                    <div class="offer-row" *ngFor="let offer of getFilteredOffers()">
                        <mat-checkbox class="margin-left-10" color="primary" (change)="selectOffer($event,offer)" [checked]="offer.checked" [disabled]="offer.disabled"></mat-checkbox>
                        <div class="offer-name" [matTooltip]="offer.offerName" [matTooltipPosition]="'right'">{{offer.offerName}}</div>
                    </div>
                </div>
            </div>
            <div class="flex-narrow sp-col-2" >
                <div>
                    <div class="reward-type-row" [matTooltip]="!hasLoyaltyConfig?'Loyalty Configuration Absent':''">
                        <div class="reward-type" [ngClass]="{'disabled-reward-text': !hasLoyaltyConfig}">Loyalty Points</div>
                        <mat-checkbox class="margin-left-10" color="primary" [checked]="rewardTypesSelected['LP']" (change)="checkRewardType($event,'LP')" [disabled]="!hasLoyaltyConfig"></mat-checkbox>
                        <span class="error-text" *ngIf="errorFieldList.includes('LP')">Please enter a valid value</span>
                    </div>
                    <div  [ngClass]="{'disabled-div': !rewardTypesSelected['LP']}">
                        <div class="width-100">
                            <label class="main-label-style">Value</label><span class="qb-imp-color">*</span>
                            <div class="rp-name-inp-container">
                                <input class="rp-name-inp" type="number" placeholder="Enter your value" maxlength="10" #inp2lp [(ngModel)]="loyaltyPointsValue"
                                (keydown)="numberInputHandler($event,10,'number');errorFieldList = [];" maxlength="10" min="0" max="9999999999" (wheel)="disableWheelScroll($event)">
                            </div>
                            <div class="input-sub">
                                <div class="inp-text-left">{{inp2lp.value.length}}/{{ inp2lp.getAttribute('maxlength')}}</div>
                            </div>
                        </div>
                    </div>
                    <app-wallet-expiry-configuration (input)="errorFieldList = []" #profileLoyaltyConfig [loyaltyExpiryConfig]="loyaltyExpiryConfig" [type]="'loyalty'" [ngClass]="{'disabled-div': !rewardTypesSelected['LP']}"></app-wallet-expiry-configuration>
                </div>
                <div>
                    <div class="reward-type-row" [matTooltip]="ledgerList.length == 0?'Ledger Configuration Absent':''">
                        <div class="reward-type" [ngClass]="{'disabled-reward-text': ledgerList.length == 0}">Wallet Cashback</div>
                        <mat-checkbox class="margin-left-10" color="primary" [checked]="rewardTypesSelected['WC']" (change)="checkRewardType($event,'WC')" [disabled]="ledgerList.length == 0"></mat-checkbox>
                        <span class="error-text" *ngIf="errorFieldList.includes('WC')">Please enter a valid value</span>
                    </div>
                    <div  [ngClass]="{'disabled-div': !rewardTypesSelected['WC']}" class="d-flex justify-content-between gap-1">
                        <div class="col-sm-6">
                            <label class="main-label-style">Value</label><span class="qb-imp-color">*</span>
                            <div class="rp-name-inp-container">
                                {{currencySymbol}}
                                <input class="rp-name-inp" type="number" placeholder="Enter your value" maxlength="10" #inp3 [(ngModel)]="cashBackValue"
                                (keydown)="numberInputHandler($event,10,'float');errorFieldList = [];" maxlength="10" min="0" max="9999999999" (wheel)="disableWheelScroll($event)">
                            </div>
                            <div class="input-sub">
                                <div class="inp-text-left">{{inp3.value.length}}/{{ inp3.getAttribute('maxlength')}}</div>
                            </div>
                        </div>
                        <div class="col-sm-6" *ngIf="ledgerList.length>0">
                            <label class="main-label-style">Ledger</label><span class="qb-imp-color">*</span>
                            <div class="rp-name-inp-container">
                                <mat-select [(ngModel)]="selectedLedgerId">
                                    <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">{{ledger.ledgerName}}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    <app-wallet-expiry-configuration (input)="errorFieldList = []" #badgeWalletConfig [walletExpiryConfiguration]="walletExpiryConfiguration" [type]="'wallet'" [ngClass]="{'disabled-div': !rewardTypesSelected['WC']}" ></app-wallet-expiry-configuration>
                </div>
            </div>
        </div>


       
        <div class="top-margin-standard">
            <div class="disabled-edit-text ms-0" *ngIf="isEditDisabled">
                Value can only be increased as {{disableEditText}}
            </div>
            <div class="flex gap-3">
                <div class="width-50">
                    <label class="main-label-style">Badge Assignment Limit Per Customer</label><span class="qb-imp-color">*</span>
                    <div class="rp-name-inp-container">
                        <input class="rp-name-inp" type="number" placeholder="Enter your value" maxlength="5" #inp21 [(ngModel)]="badgeConfig.perCustomerBadgeAssignmentLimit"
                        (keydown)="numberInputHandler($event,5,'number');errorFieldList = [];" min="0" max="99999" (wheel)="disableWheelScroll($event)">
                    </div>
                    <div class="input-sub">
                        <div class="error-text" *ngIf="errorFieldList.includes('PCBA')">
                            Please enter valid value
                        </div>
                        <div class="error-text" *ngIf="errorFieldList.includes('PCBA2')">
                            Value cannot be decreased
                        </div>
                        <div class="inp-text-left">{{inp21.value.length}}/{{ inp21.getAttribute('maxlength')}}</div>
                    </div>
                </div>
               
                <div class="d-flex flex-column">
                    <div class="label-title d-flex mb-3" [ngClass]="{'disabled-edit':!hasBudget && isEditDisabled}">
                        <span>Badge Budget</span><mat-checkbox [ngClass]="{'disable-edit-checkbox': !hasBudget && isEditDisabled}" class="custom-check" color="primary" [(ngModel)]="hasBudget" (change)="onHasBudgetChange()"></mat-checkbox>
                    </div>
                    <app-offer-budget [budgetEntity]="budgetEntity" [ngClass]="{'disabled-budget':!hasBudget}" [showBudgetLimit]="false" [displayNameForRedemptionCount]="'Total Badge Assigment Count'" #offerBudgetComp>
                    </app-offer-budget>
                    <div class="error-text" *ngIf="errorFieldList.includes('BE')">
                        Value cannot be decreased
                    </div>
                </div>
            </div>
        </div>
        

    </div>    
</div>
